import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { POSTDepartmentBody, PUTDepartmentBody } from '.'
import { IPaginatedRequest } from '../../request'

export const loadDepartments = (params: IPaginatedRequest = {}) => ({
  method: 'GET',
  url: '/modules/departments',
  params: {
    Fields: '*',
    ...params
  }
})

export const getDepartment = (DepartmentUUID: string) => ({
  method: 'GET',
  url: `/modules/departments/${DepartmentUUID}`
})

export const createDepartment = (body: POSTDepartmentBody) => ({
  method: 'POST',
  url: '/modules/departments',
  data: body
})

export const updateDepartment = (DepartmentUUID: string, body: PUTDepartmentBody) => ({
  method: 'PUT',
  url: `/modules/departments/${DepartmentUUID}`,
  data: body
})

export const deleteDepartment = (DepartmentUUID: string, dryRun: boolean) => ({
  method: 'DELETE',
  url: `/modules/departments/${DepartmentUUID}`,
  params: {
    DryRun: dryRun
  }
})

export const importDefaultDepartments = () =>
  createAsyncApiAction('gms', {
    method: 'PUT',
    url: '/modules/departments/import-defaults'
  })
